export default __webpack_public_path__ + "static/media/sudent.1cc1bf4b.svg";